import { useState, useContext } from "react"
import { GlobalContext } from "context/context/GlobalContext"
import { attachFileShippingGroup } from "services/ShippingGroupService"
import { updateOrderById } from "services/OrderServices"
import Logger from "classes/Logger"
import { TransactionCodeEnum } from "enums/TransactionCodeEnum"
import { FilesFormType } from "types/FilesFormType"
import useUserPermissions from "hooks/UseUserPermissions"
import useCancelToken from "hooks/UseCancelToken"
import { ResourcePermissionsEnum } from "enums/ResourcePermissionsEnum"

const UseClosedOrder = ({ shippingGroupId, order }: any) => {
  const [loadingClosed, setLoadingClosed] = useState(false)
  const { newCancelToken } = useCancelToken()
  const { notification, errorHander } = useContext(GlobalContext)

  const { permission } = useUserPermissions({
    resources: [ResourcePermissionsEnum.orderClosedUploadFiles],
  })

  const attachFile = async (filesShippinGroup: FileList): Promise<boolean> => {
    const formAttachFile = new FormData()

    for (let indexFile = 0; indexFile < filesShippinGroup.length; indexFile++) {
      const file = filesShippinGroup[indexFile]
      if (file) formAttachFile.append(`$attach${indexFile}`, file)
    }

    const dataOrder = await updateOrderById(
      order?.id,
      {
        custom: {
          contrato_portabilidad: "SI",
        },
      },
      newCancelToken(),
    )

    console.log(dataOrder)
    
    formAttachFile.append("tags", [...filesShippinGroup].map(({ name }) => name).join(","))
    const {
      data: { code },
    } = await attachFileShippingGroup(shippingGroupId, formAttachFile)

    return code === TransactionCodeEnum.ok
  }

  const submitFilesClosedOrder = async ({ filesShippinGroup }: FilesFormType) => {
    
    try {
      setLoadingClosed(true)

      let successAttachFiles: boolean = true

      if (filesShippinGroup) {
        successAttachFiles = await attachFile(filesShippinGroup)
      }

      if (!successAttachFiles) {
        notification?.dispatch({
          type: "ADD_NOTIFICATION",
          payload: {
            message: "Ha ocurrido un error, al cargar los archivo",
            title: "Error",
            type: "danger",
          },
        })

        return
      }

      notification?.dispatch({
        type: "ADD_NOTIFICATION",
        payload: {
          message: "Archivos cargados correctamente",
          title: "Hecho",
          type: "success",
        },
      })
      setTimeout(() => window.location.reload(), 1500)
      setLoadingClosed(false)
    } catch (error: any) {
      setLoadingClosed(false)
      Logger.error(error)
      errorHander?.dispatch({ hasError: true, code: error.response?.status })
    }
  }

  return {
    loadingClosed,
    submitFilesClosedOrder,
    hasPermissionUploadFiles: permission[ResourcePermissionsEnum.orderClosedUploadFiles],
  }
}

export default UseClosedOrder
